import React from 'react';
import { Newspaper, Radio, Award, Star, Building2, GraduationCap } from 'lucide-react';
import { CLINIC } from '../mock';
import { useLang } from '../context/LangContext';

const ITEMS = [
  { icon: Newspaper, top: 'Featured in', hiTop: 'प्रकाशित', name: 'Amar Ujala', hiName: 'अमर उजाला' },
  { icon: Radio, top: 'On air', hiTop: 'रेडियो पर', name: 'Forever FM' },
  { icon: Award, top: 'Top 3 in Ghaziabad', hiTop: 'गाज़ियाबाद में टॉप 3', name: 'ThreeBestRated' },
  { icon: Star, top: `${CLINIC.reviews} reviews`, hiTop: `${CLINIC.reviews} रिव्यू`, name: `Google ${CLINIC.rating}★` },
  { icon: Building2, top: 'Consultant experience', hiTop: 'कंसल्टेंट अनुभव', name: 'NHS, UK' },
  { icon: GraduationCap, top: 'Member', hiTop: 'सदस्य', name: 'Royal College of Physicians' },
];

export const TrustStrip = () => {
  const { tr } = useLang();
  return (
  <section data-testid="trust-strip" className="border-y border-teal-50 bg-white">
    <div className="container-x py-6">
      <div className="text-[11px] font-semibold tracking-[0.2em] uppercase text-slate-400 text-center mb-4">{tr('As featured in & recognised by', 'मीडिया और सम्मान')}</div>
      <div className="flex flex-wrap items-center justify-center lg:justify-between gap-x-8 gap-y-5">
      {ITEMS.map((it) => (
        <div key={it.name} className="flex items-center gap-2.5 opacity-80 hover:opacity-100 transition-opacity">
          <it.icon size={22} className="text-teal-600" />
          <div className="leading-tight">
            <div className="text-[10px] uppercase tracking-wider text-slate-400">{tr(it.top, it.hiTop)}</div>
            <div className="font-display text-teal-900" style={{ fontWeight: 600 }}>{tr(it.name, it.hiName)}</div>
          </div>
        </div>
      ))}
      </div>
    </div>
  </section>
  );
};
